(function () {
  'use strict';

  let pdpJdgmObs = null;
  let boostJdgmObs = null;
  var boostRunTimer = null;

  function formatAverageForDisplay(avgNum) {
    if (Number.isNaN(avgNum)) return '';
    const r = Math.round(avgNum * 10) / 10;
    if (Math.abs(r - Math.round(r)) < 1e-9) return String(Math.round(r));
    return r.toFixed(1);
  }

  function applyPdpPreviewBadgeText(badge) {
    if (!badge || !badge.classList.contains('jdgm-prev-badge')) return;
    if (badge.closest('.c-boost-jdgm-root')) return;
    const textEl = badge.querySelector('.jdgm-prev-badge__text');
    if (!textEl) return;
    const avgAttr = badge.getAttribute('data-average-rating');
    const countAttr = badge.getAttribute('data-number-of-reviews');
    if (avgAttr == null || countAttr == null) return;
    const avgNum = parseFloat(avgAttr);
    const count = parseInt(countAttr, 10);
    if (Number.isNaN(avgNum) || Number.isNaN(count)) return;
    const avgStr = formatAverageForDisplay(avgNum);
    if (!avgStr) return;
    const next = avgStr + '(' + count + ')';
    if (textEl.textContent !== next) textEl.textContent = next;
  }

  function applyBoostCollectionBadgeText(badge) {
    if (!badge || !badge.classList.contains('jdgm-prev-badge')) return;
    if (!badge.closest('.c-boost-jdgm-root')) return;
    const textEl = badge.querySelector('.jdgm-prev-badge__text');
    if (!textEl) return;
    const avgAttr = badge.getAttribute('data-average-rating');
    if (avgAttr == null) return;
    const avgNum = parseFloat(avgAttr);
    if (Number.isNaN(avgNum)) return;
    const next = formatAverageForDisplay(avgNum);
    if (!next) return;
    if (textEl.textContent !== next) textEl.textContent = next;
  }

  function runPdp() {
    const root = document.querySelector('.c-pdp-meta__review');
    if (root) {
      root.querySelectorAll('.jdgm-prev-badge').forEach(applyPdpPreviewBadgeText);
    }
  }

  function runBoost() {
    document.querySelectorAll('.c-boost-jdgm-root .jdgm-prev-badge').forEach(applyBoostCollectionBadgeText);
  }

  function runAll() {
    runPdp();
    runBoost();
  }

  window.cJdgmPreviewBadgeFormat = { runPdp: runPdp, runBoost: runBoost, runAll: runAll };

  function initPdp() {
    if (pdpJdgmObs) {
      pdpJdgmObs.disconnect();
      pdpJdgmObs = null;
    }
    const root = document.querySelector('.c-pdp-meta__review');
    if (!root) return;
    runPdp();
    pdpJdgmObs = new MutationObserver(function () {
      runPdp();
    });
    pdpJdgmObs.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-average-rating', 'data-number-of-reviews', 'class'],
    });
  }

  function scheduleBoost() {
    if (boostRunTimer) {
      clearTimeout(boostRunTimer);
    }
    boostRunTimer = setTimeout(function () {
      boostRunTimer = null;
      runBoost();
    }, 50);
  }

  function initBoostObserver() {
    if (boostJdgmObs) {
      boostJdgmObs.disconnect();
    }
    runBoost();
    if (!document.body) {
      return;
    }
    boostJdgmObs = new MutationObserver(function () {
      scheduleBoost();
    });
    boostJdgmObs.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-average-rating', 'data-number-of-reviews', 'class'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPdp();
      initBoostObserver();
    });
  } else {
    initPdp();
    initBoostObserver();
  }

  document.addEventListener('shopify:section:load', function () {
    initPdp();
    runBoost();
  });
})();
